import Router from "./components/router/Router";
import RouterProduct from "./components/router/RouterProduct";

function App() {
  return (
    <div>
        <RouterProduct/>
    </div>
  );
}

export default App;
